<template>
<div id="login-register">
    <div class="width-100">
        <div class="dividend">
            <form @submit.prevent="handleSubmit">
                <div class="form-group position-relative">
                    <input v-model="username" class="input-w-icon form-control" type="text" name="username" id="username" placeholder="Username/Email (required)" required tabindex="20" />
                </div>
                <br />
                <div class="form-group position-relative">
                    <input v-model="password" class="input-w-icon form-control" type="password" name="password" id="password" placeholder="Password (required)" required tabindex="20" />
                </div>
                <button class="login-register-btn form-control mt-4" id="submit-button" type="submit" :disabled="isloading" tabindex="40">
                    <b-spinner v-if="isloading" small> </b-spinner>
                    Login
                </button>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import * as LmsApiHelper from '../../store/LmsApiHelper';
export default {
    name: "Login",
    data() {
        return {
            username: "",
            password: "",
            isloading: false,
        };
    },
    methods: {
        async handleSubmit() {
            this.isloading = true;
            await this.login();
        },
        async login() {
            try {
                const loginData = {
                    username: this.username,
                    password: this.password
                };
                const loginResponse = await LmsApiHelper.Login(loginData);
                if (loginResponse.status === 'Success') {
                    const userType = loginResponse.payload.user.type;

                    if (userType === 'Management') {
                        const responseMessage = "Logged In Successfully!";
                        this.$toasted.success(
                            `${responseMessage} !`, {
                                theme: "outline",
                                position: "bottom-center",
                                duration: 3000,
                            }
                        );
                        this.$router.push('/Students');
                    } else {
                        this.$toasted.error(
                            `"Invalid User Type."`, {
                                icon: "exclamation-triangle",
                                theme: "outline",
                                position: "bottom-center",
                                singleton: true,
                                duration: 3000,
                            }
                        );
                    }
                } else {
                    this.$toasted.error(
                        "Login Failed. Please check your credentials.", {
                            icon: "exclamation-triangle",
                            theme: "outline",
                            position: "bottom-center",
                            singleton: true,
                            duration: 3000,
                        }
                    );
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.isloading = false;
            }
        },
    },
};
</script>

<style>
  </style>
